import { createFileRoute } from '@tanstack/react-router';

import { ProjectsPage } from '@/projects/pages';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/projects/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: ProjectsRoute
});

function ProjectsRoute() {
  return (
    <ProjectsPage />
  );
}
